import PropTypes from "prop-types";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CustomSelect } from "../CustomControls/CustomSelect";
import { CustomSearchBox } from "../CustomControls/CustomSearchBox";
import { Spinner } from "../Utils/Loaders";

export const MembersFilters = (props) => {
  const { t } = useTranslation();
  const {
    specialtiesOptions,
    protocolSpecialtiesOptions,
    isLoading,
    onChangeFilter,
  } = props;

  // adapto string[] -> [{id,name}] para que el CustomSelect renderice y el hook mande string via .id
  const practitionerSpecialties = (specialtiesOptions ?? []).map((s) => ({
    id: s,
    name: s,
  }));

  return (
    <>
      {!specialtiesOptions && <Spinner />}
      {!!specialtiesOptions && (
        <>
          <Col md={3}>
            <CustomSearchBox
              handleSearch={(value) => onChangeFilter("name", value)}
              placeholder={t("team.filters.searchByName")}
            />
          </Col>

          <Col md={3}>
            <CustomSearchBox
              handleSearch={(value) => onChangeFilter("clinicalTrial", value)}
              placeholder={t("team.filters.searchByTrial")}
            />
          </Col>

          <Col md={3}>
            <CustomSelect
              name="Speciality"
              placeholder={t("team.filters.searchBySpecialty")}
              onChange={onChangeFilter}
              isMulti={false}
              isClearable={true}
              loading={isLoading}
              options={specialtiesOptions.map((s) => ({ id: s, title: s }))}
            />
          </Col>

          <Col md={3}>
            <CustomSelect
              name="ProtocolSpeciality"
              placeholder={t("team.filters.searchByProtocolSpecialty")}
              onChange={onChangeFilter}
              isMulti={false}
              isClearable={true}
              loading={isLoading}
              options={protocolSpecialtiesOptions.map((s) => ({
                id: s,
                title: s,
              }))}
            />
          </Col>
        </>
      )}
    </>
  );
};

MembersFilters.propTypes = {
  specialtiesOptions: PropTypes.arrayOf(PropTypes.string),
  protocolSpecialtiesOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  isLoading: PropTypes.bool,
  onChangeFilter: PropTypes.func.isRequired,
};
